import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { Tool, ToolType } from '@/types'
import { createTool } from '@/lib/api'
import { Card } from '@/components/ui/Card'
import { TextField, TextAreaField, SelectField, SaveBar } from '@/components/ui/FormFields'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

const empty: Tool = {
  id: '',
  name: '',
  description: '',
  tool_type: 'acción',
  category: '',
  provider: '',
  lives_on: '',
  auth_method: '',
  scopes_available: [],
  limitations: '',
}

export function ToolNew() {
  const navigate = useNavigate()
  const [tool, setTool] = useState<Tool>(empty)
  const [saving, setSaving] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  function update<K extends keyof Tool>(key: K, value: Tool[K]) {
    setTool((prev) => ({ ...prev, [key]: value }))
  }

  async function handleSave() {
    if (!tool.id || !tool.name) {
      setResult('ID y Nombre son obligatorios')
      return
    }
    setSaving(true)
    setResult(null)
    try {
      await createTool(tool)
      navigate(`/tools/${tool.id}`)
    } catch (e) {
      setResult(e instanceof Error ? e.message : 'Error al crear')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <PendingBackendNotice endpoint="POST /tools" />
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 16 }}>Nuevo Tool</h1>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Card>
          <TextField label="ID (ej. az-nueva-tool)" value={tool.id} onChange={(v) => update('id', v)} mono />
          <TextField label="Nombre" value={tool.name} onChange={(v) => update('name', v)} />
          <TextAreaField label="Descripción" value={tool.description ?? ''} onChange={(v) => update('description', v)} />
        </Card>
        <Card>
          <SelectField
            label="Tipo"
            value={tool.tool_type}
            onChange={(v) => update('tool_type', v as ToolType)}
            options={['acción', 'integración']}
          />
          <TextField label="Categoría" value={tool.category ?? ''} onChange={(v) => update('category', v)} />
          <TextField label="Provider" value={tool.provider ?? ''} onChange={(v) => update('provider', v)} />
          <TextField label="Vive en" value={tool.lives_on ?? ''} onChange={(v) => update('lives_on', v)} mono />
          <TextField label="Auth method" value={tool.auth_method ?? ''} onChange={(v) => update('auth_method', v)} />
        </Card>
      </div>

      <SaveBar onSave={handleSave} saving={saving} result={result} />
    </div>
  )
}
